/* eslint-disable */
import { Button, Layout, message } from 'antd'
import React, { useEffect } from 'react'
// Filters Section
import Company from './Sections/Company'
import Education from './Sections/Education'
import Experience from './Sections/Experience'
import Language from './Sections/Language'
import Location from './Sections/Location'
import SearchByTitle from './Sections/SearchByTitle'
import Skills from './Sections/Skills'
// helpers
import getSearchFilters from './helpers/getSearchFilters'
// Context
import {
  setFields,
  setIsLoading,
  setSearch,
  setSearchApiObj,
  useQueryActions,
  useQuerysDispatch,
  useQuerysState
} from '../../CandidateContext/SearchQueryContext'
// Style
import { matchPath, useLocation, useParams } from 'react-router'
import { advancedSearchForCandidates, UpdateActiveCandidateData } from '../../helpers/QueryHelpers'
import './Filters.css'

const { Sider } = Layout

export default function Filters() {
  const [existedFilters, setExistedFilters] = React.useState(undefined)
  const { candidatesFilters, searchedCandidates, isLoading, searchApiObj } = useQuerysState()
  const actions = useQueryActions()
  const dispatch = useQuerysDispatch()
  const location = useLocation()
  const { jobkey } = useParams()

  const getActiveSearchQuery = async () => {
    try {
      await actions.jobPreview(jobkey)
      await actions.getSearchedCandidates(jobkey)
    } catch (e) {
      console.log(e)
    }
  }

  const simpleSearchPath = matchPath(location.pathname, {
    path: '/simplesearch',
    exact: true,
    strict: false
  })

  React.useEffect(() => {
    if (jobkey) {
      getActiveSearchQuery()
    }
  }, [jobkey])

  React.useEffect(() => {
    if (simpleSearchPath) return
    const filters = getSearchFilters(candidatesFilters?.searchJson) || {}
    const cloned = JSON.parse(JSON.stringify(filters)) || {}
    const updateFilter = {
      ...cloned,
      location: {
        ...cloned?.location,
        postCode: { ...cloned?.postCode?.postCode }
      }
    }
    delete updateFilter.postCode
    setExistedFilters(updateFilter)
    dispatch(setFields({ selectedFields: filters }))
  }, [candidatesFilters])

  const handleSearchFilters = async () => {
    if (!simpleSearchPath) {
      const normalizedPayload = {
        mustHave: {},
        shouldHave: {},
        mustNotHave: {}
      }

      if (!existedFilters || typeof existedFilters !== 'object') {
        console.warn('⚠️ No existedFilters found, skipping filter payload normalization')
        await UpdateActiveCandidateData(
          normalizedPayload,
          candidatesFilters,
          actions,
          normalizedPayload,
          searchedCandidates?.results,
          simpleSearchPath
        )
        return
      }

      Object.entries(existedFilters).forEach(([parentKey, section]) => {
        Object.entries(section || {}).forEach(([innerKey, values]) => {
          if (!values) return
          const addToPayload = (type, data) => {
            if (
              data === undefined ||
              (Array.isArray(data) && data.length === 0) ||
              (typeof data === 'string' && data.trim() === '')
            ) {
              return
            }

            let targetKey = innerKey
            if (parentKey === 'experience') {
              if (innerKey === 'years') targetKey = 'career_length'
              else if (innerKey === 'count') targetKey = 'career_count'
            }

            normalizedPayload[type][targetKey] = data
          }

          addToPayload('mustHave', values.mustHave)
          addToPayload('shouldHave', values.shouldHave)
          addToPayload('mustNotHave', values.mustNotHave)
        })
      })

      await UpdateActiveCandidateData(
        normalizedPayload,
        candidatesFilters,
        actions,
        normalizedPayload,
        searchedCandidates?.results,
        simpleSearchPath
      )
      return
    }

    if (!existedFilters || typeof existedFilters !== 'object') return

    const skills = existedFilters['skills']?.expertise || {}

    if (!Object.keys(skills).length) {
      message.error('Minimum of 1 skill required')
      return
    }

    await advancedSearchForCandidates(
      Object.entries(existedFilters),
      actions,
      searchApiObj,
      dispatch,
      setSearchApiObj,
      true,
      () => {},
      setSearch,
      setIsLoading
    )
  }

  return (
    <Sider className="Filters-body" style={isLoading ? { pointerEvents: 'none' } : undefined}>
      <div>
        <SearchByTitle existedFilters={existedFilters} setExistedFilters={setExistedFilters} />

        <Location existedFilters={existedFilters} setExistedFilters={setExistedFilters} />

        <Skills setExistedFilters={setExistedFilters} existedFilters={existedFilters} />

        <Experience existedFilters={existedFilters} setExistedFilters={setExistedFilters} />

        <Education setExistedFilters={setExistedFilters} existedFilters={existedFilters} />

        <Company setExistedFilters={setExistedFilters} existedFilters={existedFilters} />

        <Language setExistedFilters={setExistedFilters} existedFilters={existedFilters} />
      </div>

      <div className="sticky-footer">
        <Button
          type="ghost"
          style={{ borderStyle: 'solid' }}
          onClick={() => {
            setExistedFilters(undefined)
            dispatch(setSearch(undefined))
          }}
        >
          Clear
        </Button>
        <Button type="primary" block disabled={!existedFilters} onClick={handleSearchFilters}>
          Search
        </Button>
      </div>
    </Sider>
  )
}
